import type { IName } from '~/types/models'

export function Name(o: IName): IName {
  const fn = '[cynqueModules/dataObjects/Name.ts] Name |'
  if (!o) {
    throw new Error(`${fn} Name called with falsey name`)
  }

  const obj = { ...o }

  obj.descr =
    (o.firstName ?? 'no first') +
    ' ' +
    (o.lastName ?? 'no last') +
    (o.suffix ? `, ${o.suffix}` : '')

  obj.fullName =
    (o.prefix ? `${o.prefix} ` : '') +
    (o.firstName ?? 'no first') +
    ' ' +
    (o.lastName ?? 'no last') +
    (o.suffix ? `, ${o.suffix}` : '')

  obj.initials =
    o.firstName.charAt(0).toUpperCase() + o.lastName.charAt(0).toUpperCase()

  obj.lastPlusFirst = o.lastName + o.firstName
  // console.debug(`${fn} returning`, obj)
  return obj
}
